module.exports = __webpack_public_path__ + "static/media/princess_diamond.6ad2970e.jpeg";